import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/org/$organization/unmanaged-applications/$application')({
});
